import React, { useState, useEffect } from "react";
import { getSecureItem } from '../../../../utilsFunctions';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Modal,
} from "@mui/material";

export default function PaymentActionDialog({
  mobNo,
  message,
  onClose,
  compData,
  collectionAmount,
  personalDetails,
  dueCount,
  collaterals,
  penalty,
}) {
  const [open, setOpen] = useState(true);
  const [printModalOpen, setPrintModalOpen] = useState(false);
  const currency = getSecureItem("country")?.symbol;

  useEffect(() => {
    document.body.style.overflow = "auto";
  }, []);

  const convertNumberToWords = (num) => {
    if (!num) return "Zero";
    const a = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const b = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const inWords = (n) => {
      if (n < 20) return a[n];
      if (n < 100)
        return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
      if (n < 1000)
        return (
          a[Math.floor(n / 100)] +
          " Hundred" +
          (n % 100 ? " " + inWords(n % 100) : "")
        );
      if (n < 100000)
        return (
          inWords(Math.floor(n / 1000)) +
          " Thousand" +
          (n % 1000 ? " " + inWords(n % 1000) : "")
        );
      if (n < 10000000)
        return (
          inWords(Math.floor(n / 100000)) +
          " Lakh" +
          (n % 100000 ? " " + inWords(n % 100000) : "")
        );
      return num;
    };
    return inWords(parseInt(num));
  };

  const handleNotify = () => {
    setOpen(false);
    window.open(`https://wa.me/${mobNo}?text=${message}`, "_blank");
    document.body.style.overflow = "auto";
    if (onClose) onClose(true);
  };

  const handleCancel = () => {
    setOpen(false);
    document.body.style.overflow = "auto";
    if (onClose) onClose(false);
  };

  const handlePrint = () => {
    const printContent = document.getElementById("printableAreaContent");
    const WinPrint = window.open("", "", "width=800,height=700");
    WinPrint.document.write("<html><head><title>Loan Receipt</title>");
    WinPrint.document.write("<style>");
    WinPrint.document.write(`
      @media print { .no-print { display: none !important; } }
      body { font-family: Arial, sans-serif; padding: 20px; }
      .receipt-container { border: 1px solid #000; padding: 20px; width: 500px; margin: auto; }
      table { width: 100%; font-size: 14px; border-collapse: collapse; }
      td { padding: 4px 6px; vertical-align: top; }
      hr { border: none; border-top: 1px solid #000; margin: 10px 0; }
      .footer { text-align: center; font-size: 12px; margin-top: 10px; }
    `);
    WinPrint.document.write("</style></head><body>");
    WinPrint.document.write(printContent.innerHTML);
    WinPrint.document.write("</body></html>");
    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
    WinPrint.close();
  };

  const handleViewReceipt = () => {
    setPrintModalOpen(true);
  };

  const collateralFields = {
    Automobiles: ["vehicleMake", "vehicleModel", "vehicleNumber"],
    "Electronic Items": ["make", "model"],
    "Insurance Policies": ["policyNumber", "expireDate"],
    Investments: ["depositReceiptNumber", "maturityDate"],
    "Machinery and Equipment": ["make", "model", "age", "condition"],
    "Valuables and Collectibles": ["gram", "valuableType"],
    "Real Estate": ["propertyLocation", "surveyNumber"],
  };

  return (
    <>
      {/* WhatsApp Notification Dialog */}
      <Dialog
        open={open}
        onClose={handleCancel}
        disableScrollLock={true}
        aria-labelledby="whatsapp-dialog-title"
        aria-describedby="whatsapp-dialog-description"
      >
        <DialogTitle id="whatsapp-dialog-title">
          Send WhatsApp Notification?
        </DialogTitle>

        <DialogContent dividers>
          <DialogContentText id="whatsapp-dialog-description">
            Do you want to notify the customer via WhatsApp about this payment update?
          </DialogContentText>

          <div
            style={{
              backgroundColor: "#f9fafb",
              borderRadius: "10px",
              padding: "12px",
              marginTop: "10px",
              border: "1px solid #e5e7eb",
              color: "#374151",
              whiteSpace: "pre-line",
              fontSize: "0.9rem",
            }}
          >
            {decodeURIComponent(message)}
          </div>
        </DialogContent>

        <DialogActions sx={{ gap: 1.5, padding: "12px 20px" }}>
          <Button
            variant="outlined"
            color="secondary"
            sx={{ fontWeight: 600 }}
            onClick={handleCancel}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            color="success"
            sx={{ fontWeight: 600 }}
            onClick={handleNotify}
          >
            Notify on WhatsApp
          </Button>

          <Button
            variant="outlined"
            sx={{ fontWeight: 600 }}
            onClick={handleViewReceipt}
          >
            View Receipt
          </Button>
        </DialogActions>
      </Dialog>

      {/* Print Modal */}
      <Modal
        open={printModalOpen}
        onClose={() => setPrintModalOpen(false)}
        disableScrollLock={true}
      >
        <div
          style={{
            minHeight: "100vh",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "40px",
            overflowY: "auto",
            background: "rgba(0,0,0,0.3)",
          }}
        >
          <div
            id="printableAreaContent"
            style={{
              background: "#f9fafb",
              padding: "40px",
              borderRadius: "16px",
              width: "600px",
              boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
              fontFamily: "'Poppins', sans-serif",
              color: "#333",
            }}
          >
            <div className="receipt-container">
              <div
                style={{
                  textAlign: "center",
                  marginBottom: "10px",
                  fontSize: "22px",
                  fontWeight: "700",
                  color: "#1f2937",
                }}
              >
                {compData?.companyName}
              </div>

              <div
                style={{
                  textAlign: "center",
                  fontSize: "13px",
                  color: "#6b7280",
                  marginBottom: "4px",
                }}
              >
                {[
                  compData?.AddressFlatNo,
                  compData?.AddressStreet,
                  compData?.AddressLine,
                  compData?.AddressLandmark,
                  compData?.AddressCity,
                  compData?.AddressState,
                  compData?.AddressPincode,
                ]
                  .filter(Boolean)
                  .join(", ")}
              </div>

              {compData?.phone && (
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "13px",
                    color: "#6b7280",
                    marginBottom: "12px",
                  }}
                >
                  📞 {compData?.phone}
                </div>
              )}

              <hr style={{ border: "1px dashed #d1d5db", marginBottom: "12px" }} />

              <h3
                style={{
                  textAlign: "center",
                  color: "#111827",
                  fontWeight: "600",
                  marginBottom: "20px",
                }}
              >
                Loan Receipt
              </h3>

              <table style={{ width: "100%", fontSize: "14px" }}>
                <tbody>
                  <tr>
                    <td>
                      <b>Voucher printing date:</b>{" "}
                      {new Date().toLocaleDateString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <b>Loan collected date:</b>{" "}
                      {new Date().toLocaleDateString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="2">
                      <b>Voucher No:</b> {personalDetails?.loanID || "-"}/{dueCount}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="2">
                      <b>Account Holder:</b> {personalDetails?.name || "-"}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Payment Mode:</b> Cash
                    </td>
                  </tr>
                  {collaterals && collaterals.length > 0 && (
                    <>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: "10px 16px",
                          fontSize: "14px",
                          marginTop: "8px",
                        }}
                      >
                        {collaterals.map((c) => (
                          <React.Fragment key={c.collateralId}>
                            <div>
                              <b>Collateral Type:</b> {c.type}
                            </div>
                            {/* <div><b>Value:</b> {c.value}</div>
                      <div><b>Serial Number:</b> {c.serialNumber}</div>
                      <div><b>Register Date:</b> {new Date(c.registerDate).toLocaleDateString("en-IN")}</div> */}

                            {c.detailsJson &&
                              collateralFields[c.type] &&
                              collateralFields[c.type].map((field) =>
                                c.detailsJson[field] ? (
                                  <div key={field}>
                                    <b>
                                      {field
                                        .replace(/([A-Z])/g, " $1")
                                        .replace(/^./, (s) => s.toUpperCase())}
                                      :
                                    </b>{" "}
                                    {c.detailsJson[field]}
                                  </div>
                                ) : null
                              )}

                            <div style={{ gridColumn: "1 / -1" }}>
                              <hr
                                style={{
                                  border: "1px dashed #d1d5db",
                                  margin: "4px 0",
                                }}
                              />
                            </div>
                          </React.Fragment>
                        ))}
                      </div>
                    </>
                  )}
                  <tr>
                    <td>
                      <b>Due Amount</b>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {currency} {collectionAmount || "-"}
                    </td>
                  </tr>
                  {(penalty > 0) && (
                    <tr>
                      <td style={{ color: "#b91c1c" }}>
                        <b>Penalty to be applied in next Payment</b>
                      </td>
                      <td style={{ textAlign: "right", color: "#b91c1c" }}>
                        {currency}{' '}{penalty || "-"}
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td
                      colSpan="2"
                      style={{
                        padding: "10px 0",
                        background: "#ecfdf5",
                        borderRadius: "8px",
                        textAlign: "center",
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#065f46",
                        marginTop: "8px",
                      }}
                    >
                      Amount: {currency}{' '}{Number(collectionAmount).toLocaleString()}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="2"
                      style={{
                        textAlign: "center",
                      }}
                      >
                      {convertNumberToWords(collectionAmount)} Only
                    </td>
                  </tr>
                </tbody>
              </table>

              <hr style={{ border: "1px dashed #d1d5db", marginTop: "16px" }} />

              {/* <div
                style={{
                  textAlign: "center",
                  color: "#9ca3af",
                  fontSize: "12px",
                  marginTop: "10px",
                }}
              >
                ** Cheques are Subject to Realisation **
              </div> */}

              <div className="no-print" style={{ textAlign: "center", marginTop: "24px" }}>
                <button
                  onClick={handlePrint}
                  style={{
                    backgroundColor: "#2563eb",
                    color: "#fff",
                    border: "none",
                    padding: "10px 24px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontWeight: "500",
                  }}
                >
                  🖨️ Print Receipt
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}
